<template>
	<div>
		<ValidationDialog :ShowModal="ShowModal" :RouteUrl="RouteUrl" :DisplayMessage="DisplayMessage" @closeclicked="afterCloseHandled">
		</ValidationDialog>
		<SenderEmailUpdateDialog :ShowModal="showEmailUpdateModal" @onemailupdated="onEmailSubmitted">
		</SenderEmailUpdateDialog>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">My Recipient</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">

				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

					<div class="adding-recipient text-right">
						<!-- <b-dropdown id="ddown-offset" class="ddRed">
							<template slot="button-content">
								<i class="fas fa-plus"></i> New Recipient
							</template>
							<b-dropdown-item :to="'/recipient/merchantrade/add'"><img src="/static/img/icons/eremit-icon.png" height="25" width="25"> Merchantrade</b-dropdown-item>
							<b-dropdown-item :to="'/recipient/westernunion/add'"><img src="/static/img/icons/western-union-icon.png" height="25" width="25"> Western Union</b-dropdown-item>
						</b-dropdown> -->
						<!-- <router-link :to="'/recipient/add'" class="btn button-white">
											<i class="fas fa-plus"></i> New Recipient
										</router-link> -->
						<button type="button" class="btn button-white" @click.prevent="checkRecipientCount()">
							<i class="fas fa-plus"></i> New Recipient
						</button>
					</div>
					<b-tabs v-model="tabIndex" class="paymentgateway">
						<b-tab title="Merchantrade" class="mt-3">
							<kendo-grid class="recipientGrid" ref="recipientGrid" :pageable='pageable'
										:no-records="true">
								<kendo-grid-column :title="'Recipient Name'" :template="recipientName">
								</kendo-grid-column>
								<kendo-grid-column :title="'Country'" :template="recipientCountry"></kendo-grid-column>
								<kendo-grid-column :title="'Payment Mode'" :field="'PayModeName'"></kendo-grid-column>
								<kendo-grid-column :title="'Account Number'" :field="'AccountNumber'" :width="210">
								</kendo-grid-column>
								<kendo-grid-column :title="'Bank/Agent'" :template="recipientBankAgent">
								</kendo-grid-column>
								<kendo-grid-column :title="'Receiver Type'" :template="receiverType" :width="120">
								</kendo-grid-column>
								<!-- <kendo-grid-column :title="'Actions'" :command="[{ name : 'edit-recipient', text : '',iconClass : 'btn-grid-edit merchantrade' , click : onEdit },{ name : 'delete-recipient', text : '',iconClass : 'btn-grid-delete' , click : onDelete },{ name : 'sendmoney-recipient', text : '',iconClass : 'btn-grid-sendmoney' , click : onSendMoney }]" :width="150"></kendo-grid-column> -->
								<kendo-grid-column :title="'Actions'"
												   :command="[{ name : 'edit-recipient', text : '',template:mtaEdit , click : onEdit },{ name : 'delete-recipient', text : '',template:mtaDelete , click : onDelete },{ name : 'sendmoney-recipient', text : '',template:mtaSend , click : onSendMoney }]"
												   :width="130"></kendo-grid-column>
							</kendo-grid>
						</b-tab>
						<b-tab title="Western Union" class="mt-3">
							<kendo-grid class="recipientGrid" ref="recipientWesternUnionGrid" :pageable='pageable'
								:no-records="true">
								<kendo-grid-column :title="'Recipient Name'" :template="recipientName">
								</kendo-grid-column>
								<kendo-grid-column :title="'Country'" :template="recipientCountry"></kendo-grid-column>
								<kendo-grid-column :title="'Payment Mode'" :field="'PayoutModeName'">
								</kendo-grid-column>
								<!-- <kendo-grid-column :title="'Actions'" :command="[{ name : 'edit-recipient-wu', text : '',iconClass : 'btn-grid-edit westernunion' , click : onEdit },{ name : 'delete-recipient-wu', text : '',iconClass : 'btn-grid-delete' , click : onDelete },{ name : 'sendmoney-recipient-wu', text : '',iconClass : 'btn-grid-sendmoney' , click : onSendMoney }]" :width="150"></kendo-grid-column> -->
								<kendo-grid-column :title="'Actions'"
									:command="[{ name : 'edit-recipient-wu', text : '',template:wuEdit , click : onEdit },{ name : 'delete-recipient-wu', text : '',template:wuDelete , click : onDelete },{ name : 'sendmoney-recipient-wu', text : '',template:wuSend , click : onSendMoney }]"
									:width="150"></kendo-grid-column>
							</kendo-grid>
						</b-tab>
						<b-tab title="Visa" class="mt-3">
							<kendo-grid class="recipientGrid" ref="recipientVisaDirectGrid" :pageable='pageable'
								:no-records="true">
								<kendo-grid-column :title="'Recipient Name'" :template="recipientName">
								</kendo-grid-column>
								<kendo-grid-column :title="'Country'" :template="recipientCountry"></kendo-grid-column>
								<kendo-grid-column :title="'Payment Mode'" :field="'PayoutModeName'">
								</kendo-grid-column>
								<kendo-grid-column :title="'Account Number'" :width="250" :template="visaAccountNumber">
								</kendo-grid-column>
								<kendo-grid-column :title="'Actions'"
									:command="[{ name : 'edit-recipient-vd', text : '',template:vdEdit , click : onEdit },{ name : 'delete-recipient-vd', text : '',template:vdDelete , click : onDelete },{ name : 'sendmoney-recipient-vd', text : '',template:vdSend , click : onSendMoney }]"
									:width="150"></kendo-grid-column>
							</kendo-grid>
						</b-tab>
					</b-tabs>
				</div>
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>

</template>

<script>
	import $ from 'jquery'
	import Base from "../../shared/Base.vue";
	import Action from "../../shared/Action.vue";
	import Mode from "../../shared/Mode.vue";
	import CommonService from "../../services/common";
	import ValidationDialog from "../../shared/ValidationDialog.vue";
	import SenderEmailUpdateDialog from "../../shared/SenderEmailUpdate.vue";

	export default {
		name: "Recipient",
		extends: Base,
		components: {
			Action,
			Mode,
			ValidationDialog,
			SenderEmailUpdateDialog
		},
		beforeRouteEnter(to, from, next) {
			if (to.params.mode == undefined)
				next()
			else
				next(p => {
					p.tabIndex = to.params.mode == 'merchantrade' ? 0 : to.params.mode == 'westernunion' ? 1: 2;
				})
		},
		mounted() {
			this.url.init = "recipient";

			var dataSource = new kendo.data.DataSource(this.getGridKendoDataSource("recipient/list"));

			var recipientGrid = this.$refs.recipientGrid.kendoWidget();
			recipientGrid.setDataSource(dataSource);

			var dataSourceWU = new kendo.data.DataSource(this.getGridKendoDataSource("recipient/westernunion/list"));
			var recipientWesternUnionGrid = this.$refs.recipientWesternUnionGrid.kendoWidget();
			recipientWesternUnionGrid.setDataSource(dataSourceWU);

			var dataSourceVD = new kendo.data.DataSource(this.getGridKendoDataSource("recipient/visadirect/list"));
			var recipientVisaDirectGrid = this.$refs.recipientVisaDirectGrid.kendoWidget();
			recipientVisaDirectGrid.setDataSource(dataSourceVD);

		},
		data() {
			return {
				tabIndex: 0,
				kendoDataSourceWesternUnion: {},
				westernUnionPagable: {},
				recipientName: function (dataItem) {
					if (dataItem.CountryId == 251 && dataItem.ReceiverType.toUpperCase() == 'BUSINESS') {
						return `${dataItem.CompanyName}`;
					}
					return kendo.htmlEncode((dataItem.FirstName + (dataItem.MiddleName == '' || dataItem.MiddleName == null || dataItem.MiddleName == undefined ? ' ' : ' ' + dataItem.MiddleName + ' ') + dataItem.LastName)).toUpperCase();
				},
				recipientCountry: function (dataItem) { return '<img style="width:24px" src="/static/img/flags/' + dataItem.FlagCode + '.png"/> ' + dataItem.CountryName; },
				recipientBankAgent: function (dataItem) {
					console.log(dataItem);
					if (dataItem.PayModeId == 1 || dataItem.PayModeId == 21 || dataItem.PayModeId == 22 || dataItem.PayModeId == 23 || dataItem.PayModeId == 24 || dataItem.PayModeId == 28 || dataItem.PayModeId == 29) {
						return `${dataItem.BankName}`;
					}
					else if (dataItem.PayModeId == 25) {
						return '';
					}
					else if (dataItem.PayModeId == 2 || dataItem.PayModeId == 34 || dataItem.PayModeId == 35) {
						return `${dataItem.AgentCode}`;
					}
					else {
						return '';
					}
					//return dataItem.PayModeId == 1 || dataItem.PayModeId == 21 || dataItem.PayModeId == 22 || dataItem.PayModeId == 23 || dataItem.PayModeId == 24 ? `${dataItem.BankName}` : `${dataItem.AgentCode}`;
				},
				receiverType: function (dataItem) {
					return `${dataItem.ReceiverType}`;
				},
				visaAccountNumber: function (dataItem) {
					return '<img src="/static/img/icons/visa_logo.png" style="width:50px; margin-right:5px;">' + dataItem.AccountNumber;
				},

				mtaEdit: '<a role="button" title="Edit" class="k-button k-button-icontext k-grid-edit-recipient" href="\\#"><span class="btn-grid-edit merchantrade"></span></a>',
				mtaDelete: '<a role="button" title="Delete" class="k-button k-button-icontext k-grid-delete-recipient" href="\\#"><span class="btn-grid-delete"></span></a>',
				mtaSend: '<a role="button" title="Send Money" class="k-button k-button-icontext k-grid-sendmoney-recipient" href="\\#"><span class="btn-grid-sendmoney"></span></a>',

				wuEdit: '<a role="button" title="Edit" class="k-button k-button-icontext k-grid-edit-recipient-wu" href="\\#"><span class="btn-grid-edit westernunion"></span></a>',
				wuDelete: '<a role="button" title="Delete" class="k-button k-button-icontext k-grid-delete-recipient-wu" href="\\#"><span class="btn-grid-delete"></span></a>',
				wuSend: '<a role="button" title="Send Money" class="k-button k-button-icontext k-grid-sendmoney-recipient-wu" href="\\#"><span class="btn-grid-sendmoney"></span></a>',

				vdEdit: '<a role="button" title="Edit" class="k-button k-button-icontext k-grid-edit-recipient-vd" href="\\#"><span class="btn-grid-edit visadirect"></span></a>',
				vdDelete: '<a role="button" title="Delete" class="k-button k-button-icontext k-grid-delete-recipient-vd" href="\\#"><span class="btn-grid-delete"></span></a>',
				vdSend: '<a role="button" title="Send Money" class="k-button k-button-icontext k-grid-sendmoney-recipient-vd" href="\\#"><span class="btn-grid-sendmoney"></span></a>',

				ShowModal: false,
				RouteUrl: null,
				DisplayMessage: '',
				showEmailUpdateModal: false,
				showBeneModal: false,
				PayoutModeId: null,
				BeneficiaryId: null
			};
		},
		methods: {
			onEdit(event) {
				event.preventDefault();
				var grid = event.data.commandName == "edit-recipient-wu" ? this.$refs.recipientWesternUnionGrid.kendoWidget() : event.data.commandName == "edit-recipient-vd" ? this.$refs.recipientVisaDirectGrid.kendoWidget() : this.$refs.recipientGrid.kendoWidget();
				var selectedRow = $(event.currentTarget).closest("tr");
				var dataItem = grid.dataItem(selectedRow);
				if (event.data.commandName == "edit-recipient-wu")
					this.$router.push("/recipient/westernunion/edit/" + dataItem.Id);
				else if(event.data.commandName == "edit-recipient-vd")
					this.$router.push("/recipient/visadirect/edit/" + dataItem.Id);
				else
					this.$router.push("/recipient/merchantrade/edit/" + dataItem.PayModeId + "/" + dataItem.BeneficiaryId);

			},
			onSendMoney(event) {
				var self = this;
				event.preventDefault();
				var grid = event.data.commandName == "sendmoney-recipient-wu" ? self.$refs.recipientWesternUnionGrid.kendoWidget() : event.data.commandName == "sendmoney-recipient-vd" ? self.$refs.recipientVisaDirectGrid.kendoWidget() : self.$refs.recipientGrid.kendoWidget();
				var selectedRow = $(event.currentTarget).closest("tr");
				var dataItem = grid.dataItem(selectedRow);
				if (dataItem) {

					var model = {
						PayoutModeId: event.data.commandName == "sendmoney-recipient-wu" ||  event.data.commandName == "sendmoney-recipient-vd" ? dataItem.PayoutModeId :dataItem.PayModeId,
						BeneficiaryId: event.data.commandName == "sendmoney-recipient-wu" ||  event.data.commandName == "sendmoney-recipient-vd" ? dataItem.Id : dataItem.BeneficiaryId
					}
					self.PayoutModeId = model.PayoutModeId;
					self.BeneficiaryId = model.BeneficiaryId;

					window.Vue.$http.post("transaction/beneficiary/isvalid", model).then(response => {
						if (response.body) {
							if (response.body.IsSenderEmailRequired && response.body.IsValid) {
								self.showEmailUpdateModal = true;
							} else if (response.body.IsSenderEmailRequired && !response.body.IsValid) {
								self.showEmailUpdateModal = true;
								self.showBeneModal = true;
								self.DisplayMessage = response.body.DisplayMessage;
								self.RouteUrl = event.data.commandName == "sendmoney-recipient-wu" ? "/recipient/westernunion/edit/" + dataItem.Id : event.data.commandName == "sendmoney-recipient-vd" ? "/recipient/visadirect/edit/" + dataItem.Id : "/recipient/merchantrade/edit/" + dataItem.PayModeId + "/" + dataItem.BeneficiaryId;
							} else if (!response.body.IsSenderEmailRequired && !response.body.IsValid) {
								self.ShowModal = true;
								self.DisplayMessage = response.body.DisplayMessage;
								self.RouteUrl = event.data.commandName == "sendmoney-recipient-wu" ? "/recipient/westernunion/edit/" + dataItem.Id : event.data.commandName == "sendmoney-recipient-vd" ? "/recipient/visadirect/edit/" + dataItem.Id :"/recipient/merchantrade/edit/" + dataItem.PayModeId + "/" + dataItem.BeneficiaryId;
							} else if (response.body.IsWUtxnNotAllowed){
								kendo.alert(response.body.DisplayMessage);
							}else {
								var url = event.data.commandName == "sendmoney-recipient-wu" ? "/transaction/" + dataItem.Id + "/" + dataItem.PayoutModeId : event.data.commandName == "sendmoney-recipient-vd" ? "/transaction/" + dataItem.Id + "/" + dataItem.PayoutModeId : "/transaction/" + dataItem.BeneficiaryId + "/" + dataItem.PayModeId ;
								self.$router.push(url);
							}
						}


					},
						error => {

						}
					)
				}

			},
			getGridKendoDataSource(listUrl) {

				listUrl = CommonService.getBaseUrl(listUrl)
				return {
					serverPaging: true,
					serverFiltering: true,
					serverSorting: true,
					pageSize: 10,
					schema: {
						data: "Data",
						total: "Total"
					},
					transport: {
						read: {

							url: listUrl,
							contentType: "application/json; charset=UTF-8",
							type: "POST",
							beforeSend: function (xhr) {
								xhr.setRequestHeader("DeviceType", "WebApp");
								xhr.setRequestHeader("DeviceKey", CommonService.getAuthToken());
							}
						},
						parameterMap: function (data, operation) {
							if (kendo.ExternalFilter !== undefined)
								data.ExternalFilter = kendo.ExternalFilter;
							return JSON.stringify(data);
						}
					},
					error: function (xhr) {

						if (xhr.xhr.status == "401") {
							CommonService.logOut(true);
						}
					}

				};
			},

			onDelete(event) {
				event.preventDefault();
				var grid = event.data.commandName == "delete-recipient-wu" ? this.$refs.recipientWesternUnionGrid.kendoWidget() : event.data.commandName == "delete-recipient-vd" ? this.$refs.recipientVisaDirectGrid.kendoWidget() : this.$refs.recipientGrid.kendoWidget() ;

				var selectedRow = $(event.currentTarget).closest("tr");
				var dataItem = grid.dataItem(selectedRow);
				var self = this;
				if (self.isProcessing) return;
				kendo.confirm("Are you sure that you want to proceed?").then(function () {
					self.isProcessing = true;
					var url = (dataItem.PayoutModeId == 98 || dataItem.PayoutModeId == 97) ? "recipient/westernunion/delete/" + dataItem.Id : (dataItem.PayoutModeId == 101 || dataItem.PayoutModeId == 102) ? "recipient/visadirect/delete/" + dataItem.Id : "recipient/merchantrade/delete/" + dataItem.PayModeId + "/" + dataItem.BeneficiaryId

					self.$http.get(url)
						.then(
							response => {
								self.isProcessing = false;
								self.$toastr("success", "Deleted Successfully");
								grid.dataSource.page(1);
							},
							error => {
								self.isProcessing = false;
							}
						);

				});
			},

			checkRecipientCount() {
				debugger;
				window.Vue.$http.get("v2/recipient/count").then(response => {

					this.$router.push("/recipient/add");

				},
					error => {

					}
				)
			},
			onEmailSubmitted() {
				var self = this;
				if (self.showBeneModal)
					self.ShowModal = self.showBeneModal;
				else
					self.$router.push("/transaction/" + self.BeneficiaryId + "/" + self.PayoutModeId);
			},
			afterCloseHandled(value)
			{
				this.ShowModal = value;
			},
		}
	};
</script>

<style scoped>
	input[type="text"] {
		text-transform: uppercase;
	}
</style>
